import MutateGreeting from "./MutateGreeting";

export default MutateGreeting